import { SUMMARY_REPORT_OBJECT_TYPE } from "Common/dictionaries/summaryReportObjectType";
import isArray from "lodash/isArray";
import isObject from "lodash/isObject";
import isString from "lodash/isString";
import some from "lodash/some";
import addToReportDocumentObjectNodes from "./addToReportDocumentObjectNodes";
import addToReportTableRows from "./addToReportTableRows";
export default (richRef, documentObjects, setInProgressCancellable, progressRef, abortControllerRef) => async (evt) => {
    var _a, _b;
    if (!richRef.current ||
        richRef.current.readOnly ||
        !evt.target ||
        !(evt.target instanceof HTMLElement) ||
        !evt.target.closest(".dxrePage"))
        return;
    const contentJson = (_a = evt.dataTransfer) === null || _a === void 0 ? void 0 : _a.getData("object");
    if (!contentJson)
        return;
    let content;
    try {
        content = JSON.parse(contentJson);
        if (!content.Value || !content.Name)
            return;
    }
    catch (e) {
        console.warn(e);
    }
    if (!content)
        return;
    try {
        if (content.SummaryReportObjectType === SUMMARY_REPORT_OBJECT_TYPE.GRAPH_SCREEN ||
            content.SummaryReportObjectType === SUMMARY_REPORT_OBJECT_TYPE.MAP_SCREEN) {
            if (!isString(content.Value))
                return;
            richRef.current.loadingPanel.show();
            const { selection } = richRef.current;
            selection.activeSubDocument.insertPicture(selection.active, content.Value);
            richRef.current.loadingPanel.hide();
        }
        else if (content.SummaryReportObjectType === SUMMARY_REPORT_OBJECT_TYPE.DOCUMENT_OBJECT_NODES) {
            if (!isArray(content.Value) ||
                some(content.Value, e => !e.DocumentObjectId))
                return;
            setInProgressCancellable(true);
            await new Promise(processResolve => {
                setTimeout(async () => {
                    if (!content) {
                        processResolve(false);
                        return;
                    }
                    abortControllerRef.current = new AbortController();
                    await addToReportDocumentObjectNodes(richRef, documentObjects, content.Name, content.Value, progressRef, abortControllerRef, processResolve);
                });
            });
        }
        else if (content.SummaryReportObjectType === SUMMARY_REPORT_OBJECT_TYPE.TABLE_ROWS) {
            if (!content.Value || !isObject(content.Value))
                return;
            const contentValue = content.Value;
            if (!isArray(contentValue.Headers) ||
                !isArray(contentValue.Rows) ||
                some(contentValue.Headers, e => !isObject(e) || !e.Name))
                return;
            setInProgressCancellable(true);
            abortControllerRef.current = new AbortController();
            await new Promise(processResolve => {
                setTimeout(async () => {
                    if (!content) {
                        processResolve(false);
                        return;
                    }
                    abortControllerRef.current = new AbortController();
                    await addToReportTableRows(richRef, documentObjects, content.Name, contentValue.Headers, contentValue.Rows, progressRef, abortControllerRef, processResolve);
                });
            });
        }
    }
    catch (e) {
        console.warn(e);
    }
    finally {
        setInProgressCancellable(false);
        richRef.current.loadingPanel.hide();
        (_b = progressRef.current) === null || _b === void 0 ? void 0 : _b.setMessage("");
    }
};
